<template>
  <div>
    <div class="modal-backdrop" v-show="show" @click="onBlur"></div>
    <div class="modal-dialog" v-show="show">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      hideOnBlur: Boolean
    },
    watch: {
      show (val) {
        this.$emit(val ? 'onShow' : 'onHide')
      }
    },
    methods: {
      onBlur (ev) {
        if (this.hideOnBlur) {
          this.show = false
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/css/mixmin'

  .modal-backdrop,
  .modal-dialog
    position fixed
    top 0
    left 0
    width 100%
    height 100%
  .modal-backdrop
    z-index 1000
    background-color rgba(#000, 15%)
    overflow hidden
  .modal-dialog
    z-index 1080
  .modal-content
    position absolute
    top 50%
    left 50%
    width 60%
    background-color #fff
    border-radius 5px
    transform translate(-50%, -50%)
    -webkit-transform translate(-50%, -50%)
    box-shadow 0 0 10px rgba(#abb9c5, .75)
</style>



// WEBPACK FOOTER //
// modal.vue?9a159f26